// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"77ca22cf","500":"ea0d8907","952":"5819bf76"}[chunkId] + ".chunk.js";
};